import { useState, useCallback } from 'react';

export const useNotifications = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((type, title, message) => {
    setNotification({ type, title, message });
    setTimeout(() => setNotification(null), 5000);
  }, []);

  const clearNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    clearNotification
  };
};
